/**
 * Класс с утилитами общего назначения
 */
class Utils {
  constructor() {}

  /**
   * Конвертирует байты в читаемый формат (KB, MB, GB, TB)
   * @param bytes - Количество байт
   * @returns Строка с размером в читаемом формате
   */
  bytesToSize(bytes: number): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))), 10);
    return `${Math.round(bytes / Math.pow(1024, i) * 100) / 100} ${sizes[i]}`;
  }
}

export default new Utils();

/**
 * Парсинг и форматирование номера телефона в формат +7XXXXXXXXXX
 * Удаляет все нецифровые символы и приводит к единому формату
 * @param phoneNumber - Номер телефона для парсинга
 * @returns Отформатированный номер телефона
 * 
 * @example
 * ```ts
 * parsePhoneNumber('8 (900) 123-45-67') // '+79001234567'
 * parsePhoneNumber('7 900 123 45 67') // '+79001234567'
 * ```
 */
export const parsePhoneNumber = (phoneNumber: string): string => {
  return phoneNumber
    .replace(/\D/g, '')
    .replace(/^7/, '+7')
    .replace(/^8/, '+7')
    .replace('-', '')
    .replace(' ', '')
    .replace(/(\()|(\))/, '')
    .slice(0, 12);
};

/**
 * Парсинг PIN-кода, оставляет только цифры (максимум 6)
 * @param pinCode - PIN-код для парсинга
 * @returns Отформатированный PIN-код
 */
export const parsePinCode = (pinCode: string): string => {
  return pinCode
    .replace(/\D/g, '')
    .replace('-', '')
    .replace(' ', '')
    .replace(/(\()|(\))/, '')
    .slice(0, 6);
};

/**
 * Валидация PIN-кода (должен содержать ровно 6 цифр)
 * @param pinCode - PIN-код для валидации
 * @returns true если PIN-код валиден, иначе false
 */
export const validatePinCode = (pinCode: string): boolean => {
  const reg = /\d{6,6}/;
  return reg.test(pinCode);
};
